// @ts-nocheck
"use client";

import ChatSupport from "@/components/Scripts/components/ChatSupport";
import ClaretyAnalytics from "@/components/Scripts/components/ClaretyAnalytics";
import { verifyBuild } from "@/utils/verify-build";

export default function Scripts() {
  const { isDevelopment } = verifyBuild();

  return (
    <>
      {!isDevelopment && (
        <>
          <ClaretyAnalytics />
          <ChatSupport />
        </>
      )}
    </>
  );
}
